"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    "jr",
    "mr",
    "mrs",
    "ms",
    "dr",
    "prof",
    "pr",
    "sr",
    "sen",
    "sens",
    "corp",
    "rep",
    "gov",
    "atty",
    "supt",
    "det",
    "rev",
    "col",
    "gen",
    "lt",
    "cmdr",
    "adm",
    "capt",
    "sgt",
    "cpl",
    "maj",
    "esq",
    "phd",
    "adj",
    "adv",
    "asst",
    "bldg",
    "brig",
    "hon",
    "messrs",
    "mlle",
    "mme",
    "op",
    "ord",
    "pvt",
    "reps",
    "res",
    "sens",
    "sfc",
    "surg",
    "ph",
    "ds",
    "arc",
    "al",
    "ave",
    "blvd",
    "cl",
    "ct",
    "cres",
    "exp",
    "rd",
    "st",
    "dist",
    "mt",
    "ft",
    "fy",
    "hwy",
    "la",
    "pd",
    "pl",
    "plz",
    "tce",
    "vs",
    "etc",
    "esp",
    "llb",
    "md",
    "bl",
    "ma",
    "ba",
    "lit",
    "fl",
    "ex",
    "eg",
    "ala",
    "ariz",
    "ark",
    "cal",
    "calif",
    "col",
    "colo",
    "conn",
    "del",
    "fed",
    "fla",
    "ga",
    "ida",
    "id",
    "ill",
    "ind",
    "ia",
    "kan",
    "kans",
    "ken",
    "ky",
    "la",
    "md",
    "mass",
    "mich",
    "minn",
    "miss",
    "mo",
    "mont",
    "neb",
    "nebr",
    "nev",
    "mex",
    "okla",
    "ok",
    "ore",
    "penna",
    "penn",
    "pa",
    "dak",
    "tenn",
    "tex",
    "ut",
    "vt",
    "va",
    "wash",
    "wis",
    "wisc",
    "wy",
    "wyo",
    "alta",
    "ont",
    "que",
    "sask",
    "yuk",
    "jan",
    "feb",
    "mar",
    "apr",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
    "sept",
    "dept",
    "univ",
    "assn",
    "bros",
    "inc",
    "ltd",
    "co",
    "benj",
    "cos",
    "calif",
    "alex",
    "mich",
    "no"
];
